<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
      <el-row style="height: 100%;">
        <el-col :span="24" style="height: 100%;overflow-y: auto">
          <div style="height: 50px;">
            <el-cascader v-fixZoom v-if="role !== 'company'" style="width: 240px" :options="treeData" v-model="sendData.orgid" :filterable="true" placeholder="选择组织" collapse-tags
              :props="{ multiple: true, checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
              ref="orgOptions" clearable>
            </el-cascader>
            <el-autocomplete style="width: 240px" class="inline-input" v-model="p_name" clearable
                             :fetch-suggestions="querySearch" placeholder="老人姓名" :trigger-on-focus="false" @select="handleSelect">
            </el-autocomplete>
            <el-date-picker v-fixZoom :clearable="false" v-model="alarmDate" type="daterange" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2" value-format="yyyy-MM-dd" style="margin-right: 10px; width: 230px">
            </el-date-picker>
            <el-select v-fixZoom v-if="role !== 'company'" v-model="sendData.so_id" placeholder="服务商" style="width: 200px" clearable>
              <el-option v-for="item in allSupplier" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-cascader v-fixZoom v-if="role !== 'company'" style="width: 200px" :options="typeTree" v-model="sendData.st_id" :filterable="true" placeholder="服务内容" clearable
                         :props="{ checkStrictly: true, value: 'id', label: 'typename', children: 'child', emitPath: false, disabled: 'isService'}" ref="typeOptions">
              <template #default="{data}">
                <span v-if="data.is_service !== 1" style="font-style: italic;color: #999999">{{ data.typename}}</span>
                <strong v-else style="color: #1a1a1a;">{{ data.typename}}</strong>
              </template>
            </el-cascader>
            <el-select v-fixZoom v-model="sendData.is_tag" placeholder="审核状态" style="width: 150px" clearable>
              <el-option label="审核通过" :value="5"></el-option>
              <el-option label="审核失败" :value="4"></el-option>
            </el-select>
            <el-button type="primary" @click="getAllHistoryWithCid">查询</el-button>
            <el-button v-if="$store.state.user.role !== 'csd' &&  role !== 'company'" icon="el-icon-download" type="success" @click="getAllDataTable">导出</el-button>
          </div>
          <div style="max-height: calc(100% - 110px);overflow-y: auto;">
            <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="showTable"
              border style="width: 100%" highlight-current-row ref="singleTable">
              <el-table-column prop="id" label="序号" width="70" align="center"></el-table-column>
              <el-table-column prop="person_name" label="老人姓名" min-width="70" align="center"></el-table-column>
              <el-table-column prop="org_name_ext" label="所属组织" min-width="120" align="center"></el-table-column>
              <el-table-column prop="service_name" label="服务内容" min-width="120" align="center"></el-table-column>
              <el-table-column prop="start_svs_tm" label="服务时间" min-width="120" align="center"></el-table-column>
              <el-table-column prop="remark" label="服务备注" min-width="80" align="center"></el-table-column>
              <el-table-column v-if="moduletag !== 2" prop="supplier_name" label="服务商" min-width="80" align="center"></el-table-column>
              <el-table-column prop="supplier_person_name" label="服务人员" min-width="80" align="center"></el-table-column>
              <el-table-column prop="svs_tm" label="完成时间" min-width="120" align="center"></el-table-column>
              <el-table-column label="审核结果" width="120" align="center">
                <template slot-scope="scope">
                  <span style="color: #999999;" v-if="scope.row.is_tag === 1">待确认</span>
                  <span style="color: #a8cc0a;" v-if="scope.row.is_tag === 2">待完成</span>
                  <span style="color: #5097FF;" v-if="scope.row.is_tag === 3">待审核</span>
                  <span style="color: #FF7800;" v-if="scope.row.is_tag === 4">审核失败</span>
                  <span style="color: #289C90;" v-if="scope.row.is_tag === 5">已完成</span>
                  <span style="color: #999999;" v-if="scope.row.is_tag === 6">已关闭</span>
                  <span style="color: #999999;" v-if="scope.row.is_tag === 7">已反馈审核</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="primary" @click="handleClick(scope.row)" size="small">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 10px;margin-bottom:10px;text-align: center">
            <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--服务单详情-->
    <el-dialog :visible.sync="detailsShow" v-if="detailsShow" width="850px" :show-close="true" :close-on-click-modal="true" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>服务单详情</span> </div>
        <div class="line-title"></div>
      </div>
      <details-log :detailsRow="detailsRow" v-model="detailsShow" @queryAlarmEvent="queryAlarmEvent"></details-log>
    </el-dialog>
    <!--导出数据-->
    <el-dialog :visible.sync="downShow" v-if="downShow" width="550px" :show-close="true" :close-on-click-modal="true" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>导出数据</span> </div>
        <div class="line-title"></div>
      </div>
      <div style="margin: 0 30px">
        <div style="font-size: 16px;color: #58595B;height: 30px;">
          请选择需导出的数据：
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        </div>
        <div>
          <el-checkbox-group v-model="checkedTitles" @change="handleCheckedChange">
            <el-checkbox style="width: 42%;margin-right: 0px;margin-top: 10px" v-for="item in selectDown" :label="item.key" :key="item.key">{{item.title}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="margin-top: 40px;height: 50px">
          <el-row>
            <el-col :span="12"><div class="btn-close-blue" @click="downShow = !downShow">取消</div></el-col>
            <el-col :span="12"><div class="btn-send-blue" @click="getAllDataTable1">导出</div></el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {queryorg} from '../../api/organizer'
import {queryfileurl, querypersonsupplierservicerecordsext} from '../../api/service'
import {querysupplierorgnotype, querysuppliertype} from '../../api/serviceMark'
import {searcholdperson} from '../../api/serviceObject'
import detailsLog from './childComponents/detailsLog.vue'
import table2excel from '../../vendor/table2excel'
import jszip from 'jszip'
import axios from 'axios'
export default {
  name: 'serviceEvent',
  components: {detailsLog},
  data () {
    return {
      moduletag: 0,
      role: '',
      // 左边
      orgData: [],
      searchKeyword: '',
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      expandedKeys: [],
      isFirst: [],
      // 右边
      allSupplier: [],
      types: [],
      typeTree: [],
      p_name: '',
      sendData: {
        pss_id: 0,
        pid: '',
        orgid: [],
        so_id: '',
        st_id: '',
        is_tag: ''
      },
      alarmDate: [],
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      detailsShow: false,
      detailsRow: '',
      downShow: false,
      checkAll: true,
      isIndeterminate: false,
      allTitles: ['personname', 'servicename', 'orgnameext', 'projectname', 'hospitalname', 'diagnosis', 'disease', 'startsvstm', 'tmshow', 'supplierpersonname', 'svstm', 'imageIds', 'fximage'],
      checkedTitles: [],
      selectDown: [
        { title: '用户姓名', key: 'personname', type: 'text' },
        { title: '服务内容', key: 'servicename', type: 'text' },
        { title: '所属组织', key: 'orgnameext', type: 'text' },
        { title: '所属项目', key: 'projectname', type: 'text' },
        { title: '医院名称', key: 'hospitalname', type: 'text' },
        { title: '就诊科室', key: 'diagnosis', type: 'text' },
        { title: '疾病名称', key: 'disease', type: 'text' },
        { title: '服务时间', key: 'startsvstm', type: 'text' },
        { title: '完成时长', key: 'tmshow', type: 'text' },
        { title: '服务人员', key: 'supplierpersonname', type: 'text' },
        { title: '完成时间', key: 'svstm', type: 'text' },
        { title: '服务照片文件名', key: 'imageIds', type: 'text' },
        { title: '服务照片', key: 'fximage', type: 'image', height: 100, width: 100 }
      ]
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.role = this.$store.state.user.role
    if (this.role === 'company') {
      // this.sendData.orgid = [this.$store.state.user.orgid]
      this.sendData.so_id = this.$store.state.user.orgid
    }
    this.getTimeObj()
    this.querySupplierTypeData()
    this.getAllSupplier()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    // const date = new Date().format('yyyyMMdd')
    // this.alarmDate = [date, date]
    // this.queryAlarmEvent()
    const end = new Date().format('yyyy-MM-dd')
    const start = this.commonType.GetDateStr(0)
    this.alarmDate = [start.format('yyyy-MM-dd'), end]
    // console.log(this.alarmDate)
  },
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  methods: {
    handleSelect (item) {
      this.sendData.pid = item.id
    },
    querySearch (queryString, cb) {
      // console.log(queryString)
      let data = {
        lessname: queryString,
        page: 1,
        size: 9999
      }
      searcholdperson(data).then(res => {
        let re = []
        for (let i = 0; i < res.data.persons.length; i++) {
          let obj = res.data.persons[i]
          obj.value = obj.name + ' - ' + obj.h_address
          re.push(obj)
        }
        cb(re)
      }).catch(() => {})
    },
    // 服务类型
    querySupplierTypeData () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: []
      }
      querysuppliertype(params, data).then(res => {
        this.types = res.data.types
        this.getTypeTree()
      }).catch(() => {
        this.loading = false
      })
    },
    getTypeTree () {
      let lastLevel = 100
      const arr = this.types
      for (let i = 0; i < arr.length; i++) {
        arr[i].isService = false
        if (arr[i].is_service === 0) {
          arr[i].isService = true
        }
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.typeTree.push(arr[i])
        }
      }
      for (let i = 0; i < this.typeTree.length; i++) {
        const child = this.arrayToNode1(arr, this.typeTree[i].id)
        if (child.length !== 0) {
          this.typeTree[i].child = child
        }
      }
    },
    // 递归
    arrayToNode1 (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.upid === pid) {
          const arrayToNode = vm.arrayToNode1(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    // 全部服务商
    getAllSupplier () {
      let params = {
        page: 1,
        size: 99999
      }
      querysupplierorgnotype(params).then(res => {
        this.allSupplier = res.data.org
      }).catch(() => {})
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions2.shortcuts = arrTime
      this.getOrgData()
    },
    // 组织
    getOrgData () {
      this.expandedKeys = []
      this.treeData = []
      this.loading = true
      queryorg().then(res => {
        // this.getFrequency()
        this.orgData = res.data.org
        for (let i = 0; i < this.orgData.length; i++) {
          if (this.orgData[i].orgpid === -1) {
            this.expandedKeys.push(this.orgData[i].id)
          }
        }
        // 所属组织
        let lastLevel = 100
        const arr = res.data.org
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.treeData.push(arr[i])
          }
        }
        for (let i = 0; i < this.treeData.length; i++) {
          const child = this.arrayToNode(arr, this.treeData[i].id)
          if (child.length !== 0) {
            this.treeData[i].child = child
          }
        }
        this.queryAlarmEvent()
      }).catch(() => {
        this.loading = false
      })
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    blurSearch () {
      this.searchKeyword = this.searchKeyword.replace(/\s*/g, '')
      if (this.searchKeyword === '') {
        this.currentPage = 1
        this.pageSize = 10
        this.queryAlarmEvent()
      }
    },
    getAllHistoryWithCid () {
      this.currentPage = 1
      this.pageSize = 10
      this.queryAlarmEvent()
    },
    queryAlarmEvent () {
      if (this.p_name === '') {
        this.sendData.pid = ''
      }
      let data = {
        pss_id: 0,
        pid: this.sendData.pid === '' ? 0 : this.sendData.pid,
        orgid: this.sendData.orgid,
        so_id: this.sendData.so_id === '' ? 0 : this.sendData.so_id,
        st_id: this.sendData.st_id === '' ? 0 : this.sendData.st_id,
        from: this.alarmDate[0] + ' 00:00:00',
        to: this.alarmDate[1] + ' 23:59:59'
      }
      if (this.sendData.is_tag !== '' && this.sendData.is_tag !== null && this.sendData.is_tag !== undefined) {
        data.is_tag = this.sendData.is_tag
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      querypersonsupplierservicerecordsext(params, data).then(res => {
        this.loading = false
        this.showTable = res.data.records
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    handleClick (row) {
      row.supplier_type_name = row.service_name
      this.detailsRow = row
      this.detailsShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryAlarmEvent()
      if (this.searchKeyword === '') {
      } else {
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryAlarmEvent()
      if (this.searchKeyword === '') {
      } else {
      }
    },
    handleCheckAllChange (val) {
      this.checkedTitles = val ? this.allTitles : []
      this.isIndeterminate = false
    },
    handleCheckedChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.allTitles.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allTitles.length
    },
    getAllDataTable () {
      this.checkedTitles = this.allTitles
      this.isIndeterminate = false
      this.downShow = true
    },
    getAllDataTable1 () {
      this.$message({ type: 'info', message: '数据加载中，请耐心等待导出。', duration: 0 })
      this.queryAlarmEvent1()
    },
    queryAlarmEvent1 () {
      if (this.p_name === '') {
        this.sendData.pid = ''
      }
      let data = {
        pss_id: 0,
        pid: this.sendData.pid === '' ? 0 : this.sendData.pid,
        orgid: this.sendData.orgid,
        so_id: this.sendData.so_id === '' ? 0 : this.sendData.so_id,
        st_id: this.sendData.st_id === '' ? 0 : this.sendData.st_id,
        from: this.alarmDate[0] + ' 00:00:00',
        to: this.alarmDate[1] + ' 23:59:59'
      }
      if (this.sendData.is_tag !== '' && this.sendData.is_tag !== null && this.sendData.is_tag !== undefined) {
        data.is_tag = this.sendData.is_tag
      }
      let params = {
        page: 1,
        size: 9999
      }
      querypersonsupplierservicerecordsext(params, data).then(res => {
        let records = res.data.records
        this.getPhotoFile(records)
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    getPhotoFile (records) {
      // console.log(13, records)
      let fileids = []
      let downData = []
      records.forEach(item => {
        item.imgIds = []
        item.fximage = []
        item.imageIds = ''
        if (item.service_img !== '') {
          let ids = item.service_img.split(',')
          ids.forEach(val => {
            fileids.push(parseInt(val))
            item.imgIds.push(parseInt(val))
          })
        }
        let pictureArr = []
        try {
          pictureArr = JSON.parse(item.picture_requirements)
        } catch (error) {}
        pictureArr.forEach(picture => {
          if (picture.value !== '') {
            fileids.push(parseInt(picture.value))
            item.imgIds.push(parseInt(picture.value))
          }
        })
        downData.push(item)
      })
      // console.log(45, fileids)
      if (fileids.length === 0) {
        this.getphoto(downData)
      } else {
        let data = {
          fileids: fileids
        }
        queryfileurl(data).then(async res => {
          let imgArr = res.data.fileurls
          for (let i = 0; i < downData.length; i++) {
            let imgIds = downData[i].imgIds
            for (let j = 0; j < imgIds.length; j++) {
              imgArr.forEach(img => {
                if (img.id === imgIds[j]) {
                  if (window.location.host === 'kangnh.com') {
                    let uris = img.uri.split('/api/v1/web/')
                    let url = 'https://kangnh.com/api/v1/web/' + uris[1]
                    img.uri = url
                  }
                  downData[i].fximage.push(img.uri)
                }
              })
            }
          }
          // eslint-disable-next-line new-cap
          const jszip1 = new jszip()
          for (let i = 0; i < downData.length; i++) {
            downData[i].imageIds = ''
            let personName = downData[i].person_name
            let day = downData[i].svs_tm.split(' ')[0]
            for (let j = 0; j < downData[i].fximage.length; j++) {
              await axios.get(downData[i].fximage[j], {
                responseType: 'arraybuffer'
              }).then(res => {
                let pngName = day + '_' + personName + '_' + (i < 10 ? '0' + (i + 1) : (i + 1)) + '-' + (j < 10 ? '0' + (j + 1) : (j + 1)) + '.png' // i + 1 + '-' + j + 1 + '.png'
                downData[i].imageIds = downData[i].imageIds + (downData[i].imageIds === '' ? '' : ',') + pngName
                jszip1.folder('images').file('' + pngName, res.data)
                downData[i].fximage[j] = 'images/' + pngName
              })
            }
          }
          this.getphoto(downData, jszip1)
        }).catch(() => {
          this.$message.closeAll()
        })
      }
    },
    async loadImage (url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'Anonymous' // 处理跨域问题
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          canvas.width = img.width
          canvas.height = img.height
          ctx.drawImage(img, 0, 0)
          resolve(canvas.toDataURL('image/png'))
        }
        img.onerror = reject
        img.src = url
      })
    },
    getphoto (downData, zip) {
      console.log(downData)
      let aa = []
      this.checkedTitles.forEach(item => {
        for (let i = 0; i < this.selectDown.length; i++) {
          if (this.selectDown[i].key === item) {
            aa.push(this.selectDown[i])
          }
        }
      })
      const column = aa
      column.unshift({ title: '序号', key: 'index', type: 'text' })
      const data = []
      for (let i = 0; i < downData.length; i++) {
        let item = downData[i]
        let hospitalname = ''
        let diagnosis = ''
        let disease = ''
        let servicerequirements = []
        if (item.service_requirements && item.service_requirements !== '') {
          try {
            servicerequirements = JSON.parse(item.service_requirements)[1]
          } catch (error) {}
        }
        for (let j = 0; j < servicerequirements.length; j++) {
          if (servicerequirements[j].key === '医院名称') {
            hospitalname = servicerequirements[j].value
          } else if (servicerequirements[j].key === '就诊科室') {
            diagnosis = servicerequirements[j].value
          } else if (servicerequirements[j].key === '疾病名称') {
            disease = servicerequirements[j].value
          }
        }
        let startsvstm = ''
        let svstm = ''
        let tmShow = ''
        if (item.start_svs_tm !== '' && item.svs_tm !== '') {
          startsvstm = item.start_svs_tm.split(' ')[0]
          let tm1 = item.start_svs_tm.split(' ')[1]
          startsvstm = startsvstm + ' ' + tm1.split(':')[0] + ':' + tm1.split(':')[1]
          svstm = item.svs_tm.split(' ')[0]
          let tm2 = item.svs_tm.split(' ')[1]
          svstm = svstm + ' ' + tm2.split(':')[0] + ':' + tm2.split(':')[1]
          tmShow = this.util.getTimeDifference(item.start_svs_tm, item.svs_tm)
        }
        let obj = {}
        column.forEach(col => {
          if (col.key === 'index') {
            obj.index = i + 1
          } else if (col.key === 'personname') {
            obj.personname = item.person_name
          } else if (col.key === 'servicename') {
            obj.servicename = item.service_name
          } else if (col.key === 'orgnameext') {
            obj.orgnameext = item.org_name_ext
          } else if (col.key === 'projectname') {
            obj.projectname = item.project_name
          } else if (col.key === 'hospitalname') {
            obj.hospitalname = hospitalname
          } else if (col.key === 'diagnosis') {
            obj.diagnosis = diagnosis
          } else if (col.key === 'disease') {
            obj.disease = disease
          } else if (col.key === 'startsvstm') {
            obj.startsvstm = startsvstm
          } else if (col.key === 'tmshow') {
            obj.tmshow = tmShow
          } else if (col.key === 'supplierpersonname') {
            obj.supplierpersonname = item.supplier_person_name
          } else if (col.key === 'svstm') {
            obj.svstm = svstm
          } else if (col.key === 'imageIds') {
            obj.imageIds = item.imageIds
          } else if (col.key === 'fximage') {
            obj.fximage = item.fximage
          }
        })
        data.push(obj)
      }
      console.log(data)
      this.$message.closeAll()
      const excelName = '服务日志' // 文件名称
      table2excel(zip, column, data, excelName) // 生成Excel表格，自动下载
    }
  }
}
</script>

<style scoped>
.btn-close-blue{
  width: 148px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  margin: auto;
  background: #FFFFFF;
  border: 1px solid #3D83F3;
  border-radius: 17px 17px 17px 17px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #3D83F3;
}
.btn-send-blue{
  width: 148px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  margin: auto;
  background: #3D83F3;
  border: 1px solid #3D83F3;
  border-radius: 17px 17px 17px 17px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/statisticalform/serviceEvent.vue